import React from 'react';
import { motion } from 'framer-motion';
import { profileData } from '../utils/mockData';

const ChatGlyph = () => (
  <svg className="whatsapp-bubble-glyph" viewBox="0 0 32 32" aria-hidden="true" focusable="false">
    <path
      d="M8 10c0-2.2 2.5-4 6-4s6 1.8 6 4-2.5 4-6 4c-.6 0-1.2-.08-1.7-.22L8 18.5V10z"
      fill="none"
      stroke="currentColor"
      strokeWidth="1.6"
      strokeLinejoin="round"
    />
    <circle cx="11.5" cy="10" r="1.1" fill="currentColor" />
    <circle cx="14.5" cy="10" r="1.1" fill="currentColor" />
    <circle cx="17.5" cy="10" r="1.1" fill="currentColor" />
    <path
      d="M22 14.5c1.8.9 3 2.4 3 4.1 0 1.2-.6 2.3-1.6 3.1l.8 2.9-2.8-.9c-.7.2-1.4.3-2.1.3-2.8 0-5.2-1.6-6.2-3.8"
      fill="none"
      stroke="currentColor"
      strokeWidth="1.4"
      strokeLinecap="round"
      opacity="0.55"
    />
  </svg>
);

const WhatsAppBubble = () => {
  if (!profileData.whatsapp) return null;

  const openWhatsApp = () => {
    window.open(profileData.whatsapp, '_blank', 'noopener,noreferrer');
  };

  return (
    <motion.button
      type="button"
      className="whatsapp-bubble"
      onClick={openWhatsApp}
      aria-label={`Chat on WhatsApp (${profileData.phoneDisplay})`}
      data-testid="whatsapp-bubble"
      initial={{ opacity: 0, scale: 0.85, y: 16 }}
      animate={{ opacity: 1, scale: 1, y: 0 }}
      transition={{ delay: 1.2, duration: 0.5, ease: [0.645, 0.045, 0.355, 1] }}
      whileHover={{ scale: 1.03, y: -3 }}
      whileTap={{ scale: 0.97 }}
    >
      <span className="whatsapp-bubble-orbit" aria-hidden="true" />
      <span className="whatsapp-bubble-icon-wrap" aria-hidden="true">
        <ChatGlyph />
      </span>
      <span className="whatsapp-bubble-label">
        <span className="whatsapp-bubble-label-main">Say hello</span>
        <span className="whatsapp-bubble-label-sub">WhatsApp</span>
      </span>
    </motion.button>
  );
};

export default WhatsAppBubble;
